(() => {
  const rootAnchors = new Set(['#services', '#works', '#profile', '#pricing', '#faq']);

  // Shopify のメニュー項目にハッシュだけ（例: "#pricing"）が登録されていると、
  // 下層ページではそのページ自身の URL に付くだけでトップへ移動しない。
  // ヘッダーとドロワー内のリンクに限り、ルート相対（"/#pricing"）へ正規化する。
  const normalizeHeaderAnchors = () => {
    document.querySelectorAll('.section-header a[href^="#"]').forEach((link) => {
      const hash = link.getAttribute('href');
      if (hash.length > 1 && rootAnchors.has(hash)) {
        link.setAttribute('href', `/${hash}`);
      }
    });
  };

  normalizeHeaderAnchors();
  document.addEventListener('DOMContentLoaded', normalizeHeaderAnchors);

  document.addEventListener('click', (event) => {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !(event.target instanceof Element)
    ) {
      return;
    }

    const link = event.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, window.location.href);
    if (
      url.origin !== window.location.origin ||
      url.pathname !== '/' ||
      !rootAnchors.has(url.hash) ||
      window.location.pathname !== '/'
    ) {
      return;
    }

    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    const target = document.querySelector(url.hash);
    if (!target) return;

    // Same-page navigation must never leave Dawn reveal elements hidden.
    // This also protects the custom sections if reveal animations are enabled
    // again later in the theme editor.
    target.classList.remove('scroll-trigger--offscreen');
    target.querySelectorAll('.scroll-trigger--offscreen').forEach((element) => {
      element.classList.remove('scroll-trigger--offscreen');
    });

    // Desktop links use the browser's native anchor behavior. With global
    // scroll-behavior:auto this is synchronous and avoids duplicate history,
    // focus and scroll operations.
    if (!drawer || !details?.open) return;

    event.preventDefault();

    // Close the mobile drawer synchronously and release Dawn's focus trap.
    // Waiting for Dawn's 400ms close animation before a second scroll caused
    // timing-dependent upward jumps and made the page appear frozen.
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    details.querySelectorAll('details').forEach((nestedDetails) => {
      nestedDetails.removeAttribute('open');
      nestedDetails.classList.remove('menu-opening');
    });
    details.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    summary?.setAttribute('aria-expanded', 'false');
    document.querySelector('.section-header')?.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();

    if (window.location.hash === url.hash) {
      window.history.replaceState(null, '', url.hash);
    } else {
      window.history.pushState(null, '', url.hash);
    }

    window.requestAnimationFrame(() => {
      target.scrollIntoView({ block: 'start', behavior: 'auto' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }, true);
})();
